import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-fill-cross-round-icon',
  templateUrl: './lib-fill-cross-round-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibFillCrossRoundIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
